var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBellOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8667_1982)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 13.5112V15.3067H16.2V13.5112H14.4V7.22693C14.4 5.98564 14.025 4.88229 13.275 3.91691C12.525 2.95152 11.55 2.3192 10.35 2.01995V0.0448877H7.65V2.01995C6.45 2.3198 5.475 2.95212 4.725 3.91691C3.975 4.8817 3.6 5.98504 3.6 7.22693V13.5112H1.8ZM7.7292 17.473C8.0814 17.8243 8.505 18 9 18C9.4956 18.0006 9.9195 17.8249 10.2717 17.473C10.6239 17.1211 10.8 16.6983 10.8 16.2045H7.2C7.2006 16.6989 7.377 17.1217 7.7292 17.473ZM12.6 13.5112H5.4V7.22693C5.4 6.2394 5.7525 5.39401 6.4575 4.69077C7.1625 3.98753 8.01 3.63591 9 3.63591C9.99 3.63591 10.8375 3.98753 11.5425 4.69077C12.2475 5.39401 12.6 6.2394 12.6 7.22693V13.5112ZM1.0017 3.10893C0.3339 4.358 0 5.73067 0 7.22693H1.8C1.8006 6.02993 2.067 4.93017 2.5992 3.92768C3.1314 2.92519 3.8475 2.09476 4.7475 1.43641L3.69 0C2.5656 0.823541 1.6695 1.85985 1.0017 3.10893ZM16.9983 3.10893C17.6661 4.358 18 5.73067 18 7.22693H16.2C16.1994 6.02993 15.933 4.93017 15.4008 3.92768C14.8686 2.92519 14.1525 2.09476 13.2525 1.43641L14.31 0C15.4344 0.823541 16.3305 1.85985 16.9983 3.10893Z",
    fill: "var(--secondary-7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8667_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutlined);
export default __webpack_public_path__ + "static/media/bellOutlined.c355b06f70b258fe52cedaa04d7ec1b3.svg";
export { ForwardRef as ReactComponent };